import { createAction } from 'redux-act';

export const resetFiltersAndResult = createAction('INSERT_PRODUCTS__RESET_FILTERS_AND_RESULT');
